import { createAsyncThunk } from '@reduxjs/toolkit';

// Services
import { CoreService } from '../../services/core.service';

// Slices & Thunks
import { CoreSliceActions } from './core.slice';

// Models
import { ISpeciality } from '../../interfaces/core.interfaces';

export enum ECoreThunks {
  SetCurrentPath = 'CORE/setCurrentPath',
  FetchLanguagesList = 'CORE/fetchLanguagesList',
  FetchCountriesList = 'CORE/fetchCountriesList',
  FetchSpecializations = 'CORE/fetchSpecializations',
  ClearSpecializations = 'CORE/clearSpecializations',
  FetchSpecialities = 'CORE/fetchSpecialities',
  FetchCompanyFee = 'CORE/fetchCompanyFee',
}

export const fetchCompanyFee = createAsyncThunk(
  ECoreThunks.FetchCompanyFee,
  async (_, { dispatch }) => {
    dispatch(CoreSliceActions.loadCompanyFee());
    const { data, error } = await CoreService.fetchCompanyFee();
    if (!data) {
      return dispatch(CoreSliceActions.loadCompanyFeeError(error ?? 'Error'));
    }
    return dispatch(CoreSliceActions.loadCompanyFeeSuccess(data));
  }
);

export const fetchLanguages = createAsyncThunk(
  ECoreThunks.FetchLanguagesList,
  async (_, { dispatch }) => {
    dispatch(CoreSliceActions.loadLanguages());
    const data = await CoreService.fetchLanguagesList();
    if (!data?.languages) {
      return dispatch(CoreSliceActions.loadLanguagesError());
    }
    return dispatch(CoreSliceActions.loadLanguagesSuccess(data.languages));
  }
);

export const fetchCountries = createAsyncThunk(
  ECoreThunks.FetchCountriesList,
  async (_, { dispatch }) => {
    dispatch(CoreSliceActions.loadCountries());
    const data = await CoreService.fetchCountriesList();
    if (!data?.countries) {
      return dispatch(CoreSliceActions.loadCountriesError());
    }
    return dispatch(CoreSliceActions.loadCountriesSuccess(data.countries));
  }
);

export const fetchSpecializations = createAsyncThunk(
  ECoreThunks.FetchSpecializations,
  async ({ speciality, withoutDispatch = false }: {
    speciality: ISpeciality[],
    withoutDispatch?: boolean
  }, { dispatch }) => {
    dispatch(CoreSliceActions.loadSpecializations());
    const data = await CoreService.fetchSpecializationsList(speciality);
    if (!data?.specializations) {
      if (!withoutDispatch) dispatch(CoreSliceActions.loadSpecializationsError());
      return [];
    }
    if (!withoutDispatch) dispatch(CoreSliceActions.loadSpecializationsSuccess(data.specializations));
    return data.specializations;
  }
);

export const clearSpecializations = createAsyncThunk(
  ECoreThunks.ClearSpecializations,
  async (_, { dispatch }) => {
    return dispatch(CoreSliceActions.clearSpecializations());
  }
);

export const fetchSpecialities = createAsyncThunk(
  ECoreThunks.FetchSpecialities,
  async (_, { dispatch }) => {
    dispatch(CoreSliceActions.loadSpecialities());
    const data = await CoreService.fetchSpecialitiesList();
    if (!data?.specialities) {
      return dispatch(CoreSliceActions.loadSpecialitiesError());
    }
    return dispatch(CoreSliceActions.loadSpecialitiesSuccess(data.specialities));
  }
);

export const setCurrentPath = createAsyncThunk(
  ECoreThunks.SetCurrentPath,
  (path: string, { dispatch }) => {
    return dispatch(CoreSliceActions.setCurrentPath(path));
  }
);
